export default {
  isType (identifier) {
    return identifier === 'address'
  }
}
